import { createStore, RequestStatus } from "common-frontend-components";
const { get, set, useStore, fetchStore } = createStore({ getDefaultValues: () => ({
        contacts: [],
        requestStatus: RequestStatus.pending,
    }) });
export const contactStore = {
    getContacts: () => get().contacts,
    setContacts: (contacts) => set({ contacts }),
    useContacts: () => useStore(fetchStore.contacts),
    getRequestStatus: () => get().requestStatus,
    // tslint:disable-next-line:no-shadowed-variable
    setRequestStatus: (requestStatus) => { console.log({ requestStatus }); const s = get(); s.requestStatus = requestStatus; set({ requestStatus }); },
    useRequestStatus: () => useStore(fetchStore.requestStatus),
};
//# sourceMappingURL=contactStore.js.map